"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _antd = require("antd");

require("antd/lib/modal/style/index");

require("antd/lib/button/style/index");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var UserInfoOutdate = function UserInfoOutdate(props) {
  var _useState = (0, _react.useState)(10),
      _useState2 = _slicedToArray(_useState, 2),
      count = _useState2[0],
      setCount = _useState2[1];

  var _useRef = (0, _react.useRef)({
    timer: null
  }),
      current = _useRef.current;

  var resetStorage = function resetStorage() {
    sessionStorage.removeItem('GDUSERID');
    sessionStorage.removeItem("".concat(props.appId, "-authorityRouters"));
    localStorage.removeItem('userInfo');
  };

  var toLogin = function toLogin() {
    resetStorage();
    props.onToLogin();
  };

  var updateInbfo = function updateInbfo() {
    resetStorage();
    props.onUpdateInfo();
  };

  (0, _react.useEffect)(function () {
    current.timer && clearInterval(current.timer);

    if (props.showModal) {
      setCount(10);
      current.timer = setInterval(function () {
        setCount(function (c) {
          return c - 1;
        });
      }, 1000);
    }
  }, [props.showModal]);
  (0, _react.useEffect)(function () {
    if (count <= 0) {
      current.timer && clearInterval(current.timer);
      updateInbfo();
    }
  }, [count]);
  return /*#__PURE__*/_react["default"].createElement(_antd.Modal, {
    title: "\u767B\u5F55\u4FE1\u606F\u53D8\u66F4",
    visible: props.showModal,
    closable: false,
    maskClosable: false,
    footer: [/*#__PURE__*/_react["default"].createElement(_antd.Button, {
      key: "login",
      onClick: toLogin
    }, "\u91CD\u65B0\u767B\u5F55"), /*#__PURE__*/_react["default"].createElement(_antd.Button, {
      key: "update",
      type: "primary",
      onClick: updateInbfo
    }, "\u66F4\u65B0\u7528\u6237\u4FE1\u606F")]
  }, /*#__PURE__*/_react["default"].createElement("p", null, "\u7CFB\u7EDF\u68C0\u6D4B\u5230\u60A8\u7684\u767B\u5F55\u4FE1\u606F\u5DF2\u53D8\u66F4\uFF0C\u60A8\u53EF\u4EE5\u9009\u62E9\u66F4\u65B0\u7528\u6237\u4FE1\u606F\u6216\u8005\u91CD\u65B0\u767B\u5F55\u3002\u5982\u65E0\u64CD\u4F5C\uFF0C\u5012\u8BA1\u65F6\u7ED3\u675F\u4F1A\u81EA\u52A8\u66F4\u65B0\u7528\u6237\u4FE1\u606F"), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("p", {
    style: {
      color: '#409EFF'
    }
  }, count, " \u79D2\u540E\u5C06\u81EA\u52A8\u66F4\u65B0\u7528\u6237\u4FE1\u606F\uFF0C\u5E76\u8FD4\u56DE\u7CFB\u7EDF\u9996\u9875"));
};

var _default = UserInfoOutdate;
exports["default"] = _default;
//# sourceMappingURL=index.js.map
